export default [

{
  path: '/settings/exam-types',
  name: 'settings.exam-types',
  component: () => import('@/views/exam-types/ExamTypesIndex.vue'),
  meta: { requiresAuth: true,
          title: 'examTypes.breadcrumbs.examTypes'

   },
  children:[

{
  path: '/settings/exam-types/create',
  name: 'settings.exam-types.create',
  component: () => import('@/views/exam-types/ExamTypesAdd.vue'),
  meta: { requiresAuth: true,
            title: 'examTypes.breadcrumbs.addNew'
   }
},
{
  path: '/settings/exam-types/:id/edit',
  name: 'settings.exam-types.edit',
  component: () => import('@/views/exam-types/ExamTypesEdit.vue'),
  meta: { requiresAuth: true,
            title: 'examTypes.breadcrumbs.edit'
   }
}
  ]
},

];